import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/app/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackgroundAudioProvider"] */ "/app/app/contexts/BackgroundAudioProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MediaProvider"] */ "/app/app/contexts/MediaContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/app/app/contexts/SessionContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SocketProvider"] */ "/app/app/contexts/SocketContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@livekit/components-styles/dist/general/index.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@livekit/components-styles/dist/general/prefabs/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/styles/globals.css");
